import React from 'react';
import PlantCard from '../components/PlantCard';
import plantsData from '../data/plants.json';

export default function Plants() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Our Plant Collection
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Browse our wide selection of indoor plants for every skill level and space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:px-20 gap-8">
          {plantsData.map(plant => (
            <PlantCard key={plant.plantId} plant={plant} />
          ))}
        </div>
      </div>
    </div>
  );
}